<template>
  <div class="main" style="margin-top: 0px;padding-top: 0px">
    <div class="et-contian">
      <div class="et-title">亮照申请</div>
      <form action="../assets/site/persistent/addSiteBase" id="applyForm" method="post">
        <div class="et-items">
          <div class="et-items-title">网站所有者情况</div>
          <div class="et-items-list">
            <div class="et-item-input">
              <label><span class="icon_red">*</span>企业名称</label>
              <input placeholder="请输入企业名称" type="text" id="companyName" name="companyName"
                     v-model="siteBaseInfo.companyName">
            </div>
            <div class="et-item-input">
              <label>注册资本</label>
              <input placeholder="请输入注册资本" type="number" name="companyRegisterMoney"
                     v-model="siteBaseInfo.companyRegisterMoney" style="padding-right:48px;">
            </div>
            <div class="et-item-input">
              <label><span class="icon_red">*</span>法定代表人</label> <input placeholder="请输入法定代表人"
                                                                         type="text" name="companyLegalPersion"
                                                                         id="companyLegalPersion"
                                                                         v-model="siteBaseInfo.companyLegalPerson">
            </div>
            <div class="et-item-input1">
              <div>
                <label>成立时间</label>
                <el-date-picker
                  v-model="siteBaseInfo.companyCreateTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </div>
            <div class="et-item-input">
              <label><span class="icon_red">*</span>统一社会信用代码</label>
              <input placeholder="请输入统一社会信用代码" type="text" name="companyNumber" id="companyNumber"
                     v-model="siteBaseInfo.companyNumber">
            </div>
            <div class="et-item-input">
              <label>登记机关</label>
              <input placeholder="请输入登记机关" type="text" name="registerOffice" v-model="siteBaseInfo.registerOffice">
            </div>
            <div class="et-item-input1">
              <label style="vertical-align: top;"><span class="icon_red">*</span>申请工商单位</label>
              <div style="margin-left: 160px;margin-top: -40px">
                <el-popover
                  placement="bottom-start"
                  trigger="click"
                  popper-class="grid-tree-popover"
                  v-model="showTree"
                >
                  <el-scrollbar class="grid-tree-contain">
                    <el-tree
                      :load="loadNode"
                      :props="props1"
                      node-key="value"
                      highlight-current
                      lazy
                      accordion
                      @node-click="handleNodeClick"
                      class="grid-tree-style"
                      ref="elTree"
                    ></el-tree>
                  </el-scrollbar>
                  <el-input
                    placeholder="请选择所属管辖单位"
                    v-model="value"
                    :suffix-icon="showTree?'el-icon-arrow-up':'el-icon-arrow-down'"
                    readonly="readonly"
                    slot="reference"
                    class="fili-style"
                  ></el-input>

                </el-popover>
              </div>
            </div>
            <div class="et-item-input" style="margin-left: 0px">
              <label><span class="icon_red">*</span>类型</label>
              <el-select id="companyType" name="companyType" v-model="siteBaseInfo.companyType">
                <el-option v-for="item in companyTypeList" :value="item.id" :label="item.typeName"/>
              </el-select>
            </div>
            <div class="et-item-input1">
              <label><span class="icon_red">*</span>营业期限</label>
              <el-date-picker
                v-model="siteBaseInfo.operateTimeStart"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              />
              &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;------
              <el-date-picker
                v-model="siteBaseInfo.operateTimeEnd"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div class="et-item-input full-input">
              <label><span class="icon_red">*</span>地址</label>
              <input placeholder="联系人或者企业地址" type="text" name="address" v-model="siteBaseInfo.address">
            </div>
            <div class="et-item-input et-item-textarea">
              <label><span class="icon_red">*</span>经营范围</label>
              <textarea placeholder="请输入经营范围" name="operateScope" v-model="siteBaseInfo.operateScope"></textarea>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="et-items">
          <div class="et-items-title">网站基本情况</div>
          <div class="et-items-list">
            <div class="et-item-input">
              <label><span class="icon_red">*</span>网站名称</label>
              <input placeholder="请输入网站名称" type="text" name="siteName" id="siteName" v-model="siteBaseInfo.siteName">
            </div>
            <div class="et-item-input">
              <label><span class="icon_red">*</span>网站类型</label>
              <el-select name="siteType" v-model="siteBaseInfo.siteType" placeholder="请选择">
                <el-option value="1" label="独立交易网站"/>
                <el-option value="5" label="独立非交易网站"/>
                <el-option value="4" label="交易平台"/>
                <el-option value="2" label="辖区内平台网店"/>
                <el-option value="3" label="辖区外平台网店"/>
              </el-select>
            </div>
            <div class="et-item-input">
              <label><span class="icon_red">*</span>交易类型</label>
              <el-select name="siteType" v-model="siteBaseInfo.dealType" placeholder="请选择">
                <el-option value="1" label="交易"/>
                <el-option value="2" label="非交易"/>
              </el-select>
            </div>
            <div class="et-damain">
              <div class="et-item-input">
                <label><span class="icon_red">*</span>网站网址</label>
                <input type="text" name="siteDomainItem" id="siteDomainItem" placeholder="例如：baidu.com" maxlength="100"
                       v-model="siteBaseInfo.siteDomain">
              </div>
            </div>
            <div class="et-item-input et-item-textarea">
              <label>网站说明</label>
              <textarea v-model="siteBaseInfo.siteDescription"></textarea>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="et-items">
          <div class="et-items-title">申请人信息</div>
          <div class="et-items-list">
            <div class="et-item-input full-width">
              <label><span class="icon_red">*</span>姓名</label> <input
              type="text" name="applyName" id="applyName" v-model="siteBaseInfo.applyName">
            </div>
            <div class="et-item-input full-width">
              <label><span class="icon_red">*</span>手机</label> <input
              type="text" name="applyPhone" id="applyPhone" v-model="siteBaseInfo.applyPhone">
            </div>
            <div class="et-item-input full-width">
              <label><span class="icon_red">*</span>邮箱</label>
              <input
                type="text" name="applyEmail" id="applyEmail" v-model="siteBaseInfo.applyEmail">
              <span style="color:#fd5f39"> (此邮箱接收亮照信息)</span>
            </div>
            <div class="et-item-input ayui_vail full-width">
              <label><span class="icon_red">*</span>邮箱验证码</label> <input placeholder="请输入邮件中的验证码"
                                                                         type="text" id="verCode" name="verCode"
                                                                         v-model="siteBaseInfo.verCode">
              <span style="cursor:pointer">
                <a class="rg-vali-title send_num" id="sendButton"
                   :style="isSend ? 'background-color:#ccc;margin-left: 0px':'background-color:#5289e2;margin-left: 0px'"
                   style="background-color:#5289e2"
                   @click="sendEmail"><span v-if="isSend"
                                            style="background:rgba(0,0,0,0) none repeat scroll !important;">{{
                    downCount
                  }}</span>{{ sendMsg }}</a>
              </span>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="et-btn" id="apply_submit" @click="submit">申请</div>
        <div class="ay_botton ay_btn_1" style="text-align: center;display:none">申请</div>
      </form>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'
import utilAPi from "../assets/js/utils";

let id = 0;
export default {
  name: 'applySiteBaseInfo',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      value: '',
      showTree: false,
      props1: {
        isLeaf: 'leaf'
      },
      sendMsg: '发送验证码',
      downCount: 60,
      isSend: false,
      isLogin: false,
      orgList: [],
      companyTypeList: [],
      siteBaseInfo: {
        updateTime: '',
        verCode: null,
        siteBaseId: null,
        companyName: null,
        companyLegalPerson: null,
        companyNumber: null,
        companyType: null,
        companyRegisterMoney: null,
        companyCreateTime: null,
        registerOffice: null,
        operateTimeStart: null,
        operateTimeEnd: null,
        address: null,
        operateScope: null,
        siteType: null,
        siteDomain: null,
        siteName: null,
        siteDescription: null,
        orgId: null,
        orgCode: null,
        orgName: null,
        applyStatus: null,
        description: null,
        isOwned: null,
        ownerOrg: null,
        ownerOrgCode: null,
        dealType: null,
        applyPhone: null,
        applyName: null,
        clientUserId: null,
        applyEmail: null
      },
      userInfo: {
        legalPerson: null,
        applyIdNumber: null,
        applyName: null,
        mobile: null,
        verCode: null,
        email: null,
        legalIdNumber: null,
        userName: null,
        userType: '2',
        password: null,
        companyNumber: null,
        repeatPwd: null
      }
    }
  },
  created: function () {
    this.getUserInfo()
    let localDate = localStorage.getItem('send_email')
    if (localDate != null) {
      let timeCount = ((Date.now() - localDate) / 1000).toFixed(0)
      if (timeCount < 60) {
        this.isSend = true
        this.downCount = 60 - timeCount
        var interval = null
        interval = setInterval(() => {
          this.downCount = this.downCount - 1
          if (this.downCount <= 0) {
            clearInterval(interval);
            this.sendMsg = '发送验证码'
            this.isSend = false
          }
        }, 1000)
      }
    }
  }, methods: {
    handleNodeClick(data) {
      this.siteBaseInfo.orgName = data.label;
      this.value = data.label;
      this.siteBaseInfo.orgId = data.value;
      this.siteBaseInfo.orgCode = data.code;
      this.showTree = false;
    },
    loadNode(node, resolve) {
      let _self = this
      if (node.level === 0) {
        _self.axios.get(_self.api.orgQuery).then(data => {
          let _arr = []
          if (data.data && data.data.code == 10000) {
            let _obj = {};
            _obj.value = data.data.obj && data.data.obj.id;
            _obj.label = data.data.obj && data.data.obj.name;
            _obj.code = data.data.obj && data.data.obj.orgCode;
            _obj.leaf = false;
            _arr.push(_obj);
            return resolve(_arr)
          } else {
            return resolve(_arr)
          }
        })
      } else {
        if (!node.isLeaf && node.key) {
          _self.axios.get(_self.api.orgQuery + '?orgId=' + node.key).then(res => {
            if (res.data && res.data.code == 10000) {
              const orgArr = [];
              res.data.obj.forEach(function (item) {
                let _obj = {};
                _obj.value = item.id;
                _obj.label = item.name;
                _obj.code = item.orgCode;
                _obj.leaf = item.haveChild == 1 ? false : true;
                orgArr.push(_obj)
              })
              resolve(orgArr);
            } else {
              resolve()
            }
          })
        } else {
          resolve([])
        }
      }
    },
    getUserInfo() {
      let _self = this
      _self.axios.get(
        _self.api.getUserInfo
      ).then(res => {
        if (res.data.code === 10000) {
          this.isLogin = true
          this.userInfo = res.data.obj
          this.selectCompanyType()
        } else {
          this.$router.push({
            path: '/index'
          })
          this.isLogin = false
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 点击申请
     */
    submit() {
      if (!this.checkInput()) {
        return
      }
      let _self = this
      _self.axios.post(_self.api.applySiteBaseInfoUrl + '/' + this.siteBaseInfo.verCode, this.siteBaseInfo).then(res => {
        if (res.data.code == 10001) {
          this.$router.push({
            path: '/index'
          })
        } else if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message.success(res.data.message)
          this.$router.push({
            path: '/index'
          })
        }
      }).catch(err => {
        this.$message.error('网络连接异常')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    /**
     * 点击发送邮件
     */
    sendEmail() {
      if (this.isSend) {
        this.$message.warning('请稍后重试!')
        return
      }
      if (this.siteBaseInfo.applyEmail == null) {
        this.$message.warning('请填写邮箱!')
        return
      }
      var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!verify.test(this.siteBaseInfo.applyEmail)) {
        this.$message.warning('邮箱格式错误, 请重新输入')
        return
      }
      if (this.isSend) {
        return
      }
      localStorage.setItem('send_email', Date.now())
      let _self = this
      _self.axios.get(
        _self.api.sendEmailCodeByEmail + '?email=' + this.siteBaseInfo.applyEmail
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code === 10000) {
          localStorage.setItem('send_email', Date.now())
          this.$message.success('发送成功!')
          this.isSend = true
          this.downCount = 60
          this.isSend = true
          this.sendMsg = '秒后重试'
          var interval = null
          interval = setInterval(() => {
            this.downCount = this.downCount - 1
            if (this.downCount <= 0) {
              clearInterval(interval);
              this.sendMsg = '发送验证码'
              this.isSend = false
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    handlerChange(value) {
      if (value) {
        // 筛选条件得存货分类
        this.siteBaseInfo.orgId = value[value.length - 1]
      } else {
        this.siteBaseInfo.orgId = null
      }
      // 选完隐藏
      this.$refs.refHandle.dropDownVisible = false
    },
    /**
     * 查询企业类型分类下拉框
     */
    selectCompanyType() {
      let _self = this
      _self.axios.get(
        _self.api.companyTypeList
      ).then(results => {
        this.companyTypeList = results.data.obj
        if (results.data.code === 10001) {
          this.isLogin = false
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 检查表单
     */
    checkInput() {
      let flag = true
      if (this.siteBaseInfo.companyName == null) {
        flag = false
        this.$message.warning('请填写企业名称!')
      } else if (this.siteBaseInfo.companyLegalPerson == null) {
        this.$message.warning('请填写法定代表人!')
        flag = false
      } else if (this.siteBaseInfo.companyNumber == null) {
        this.$message.warning('请填写统一社会信用代码!')
        flag = false
      } else if (this.siteBaseInfo.orgId === null) {
        this.$message.warning('请选择工商单位!')
        flag = false
      } else if (this.siteBaseInfo.companyType === null) {
        this.$message.warning('请选择网站类型!')
        flag = false
      } else if (this.siteBaseInfo.operateTimeStart === null) {
        this.$message.warning('请选择经营期限开始时间!')
        flag = false
      } else if (this.siteBaseInfo.operateTimeEnd === null) {
        this.$message.warning('请选择经营期限结束时间!')
        flag = false
      } else if (this.siteBaseInfo.operateTimeStart > this.siteBaseInfo.operateTimeEnd) {
        this.$message.warning('营业期限开始时间不能大于结束时间!')
        flag = false
      } else if (this.siteBaseInfo.address === null) {
        this.$message.warning('请输入地址!')
        flag = false
      } else if (this.siteBaseInfo.operateScope === null) {
        this.$message.warning('请输入经营范围!')
        flag = false
      } else if (this.siteBaseInfo.siteName === null) {
        this.$message.warning('请输入网站名称!')
        flag = false
      } else if (this.siteBaseInfo.dealType === null) {
        this.$message.warning('请选择交易类型!')
        flag = false
      } else if (this.siteBaseInfo.siteType === null) {
        this.$message.warning('请选择网站类型!')
        flag = false
      } else if (this.siteBaseInfo.siteDomain === null) {
        this.$message.warning('请网站网址!')
        flag = false
      } else if (this.siteBaseInfo.applyName === null) {
        this.$message.warning('请输入姓名!')
        flag = false
      } else if (this.siteBaseInfo.applyName === null) {
        this.$message.warning('请输入手机!')
        flag = false
      } else if (this.siteBaseInfo.applyName === null) {
        this.$message.warning('请输入邮箱!')
        flag = false
      } else if (this.siteBaseInfo.verCode === null) {
        this.$message.warning('请输入验证码!')
        flag = false
      }
      return flag
    }
  }
}
</script>

<style>

@import '../assets/css/newStyle.css';

.grid-tree-popover {
  padding: 0;
  width: auto;
  min-width: 220px;
  max-width: 550px;
  max-height: 400px
}

.grid-tree-contain {
  position: relative;
  width: 100%;
}

.el-scrollbar__wrap {
  max-height: 400px;
  min-height: 160px;
  padding: 8px 0px 16px 0px;
}


.el-tree-node__children {
/ / overflow: visible !important;
}

.el-tree-node__content {
  height: 34px;
  padding-right: 20px;
}

.el-tree-node__expand-icon {
  font-size: 16px;
}

.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 90%;
}

.et-contian .et-items .et-items-list .et-item-input input[type='text'] {
  width: 280px;
  height: 36px;
  line-height: 36px;
  border-radius: 3px;
  border: 1px solid #dfe1e8;
  color: #444;
  padding: 0 10px;
  font-size: 14px;
}

.el-cascader .el-input .el-icon-arrow-down {
  background: rgba(0, 0, 0, 0) none repeat scroll !important;
  -webkit-transition: -webkit-transform .3s;
  transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  font-size: 14px;
  margin-right: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/applySiteBaseInfo.vue